import {
  generateGetInfiniteResourceKey,
  generateGetResourceKey,
  generateHttpGet,
} from "../../utils/fetcherUtils";

import { Params, Result } from "./typing";

export const httpGet$GetGalleryOfferList = generateHttpGet<Params, Result>(
  Result.parse
);

export const getResourceKey$GetGalleryOfferList =
  generateGetResourceKey<Params>(["642e32dc-bcad-4db5-9d8b-9d0f6d2c2c2b"]);

export const getInfiniteResourceKey$GetGalleryOfferList =
  generateGetInfiniteResourceKey<Params>([
    "3740793d-c5ba-4bd5-9374-445aa5108d81",
  ]);
